import React, { ReactElement, useState, useEffect, useRef } from "react";
import { TagCloud } from "react-tagcloud";

import apiRequest from "../../../apis/request";
import { getUserAnswers, updatePollResult } from "../../../apis/firebase";

//types
import { PollWordCloudType } from "../../../types";

import { useTranslation } from "react-i18next";

const WordCloud = (props: PollWordCloudType): ReactElement => {
  const [loading, setIsLoading] = useState(false);
  const [response, setIsResponse] = useState(false);

  const [textField, setTextField] = useState("");

  const [wordCloudList, setWordCloudList] = useState([]);
  const [hasAnswered, setHasAnswered] = useState(false);

  const { t } = useTranslation();

  const {
    allowMultipleAnswers,
    answerCharLimit,
    question,
    sessionId,
    pollId,
    trackId,
    showResults,
  } = { ...props };

  useEffect(() => {
    getHasAnswered();

    updatePollResult(pollId, sessionId, (data) => {
      if (data && data?.answers) {
        let totalAns = data.totalNumOfAnswers;
        let _answers = Object.entries(data?.answers);
        _answers = _answers?.map((d) => ({
          value: d[0],
          count: d[1],
        }));
        setWordCloudList(_answers);
      }
    });
  }, []);

  const getHasAnswered = async () => {
    const userAnswers = await getUserAnswers(pollId, sessionId);

    setHasAnswered(!!userAnswers && userAnswers.length > 0);
  };

  useEffect(() => {
    if (hasAnswered) {
      setIsResponse(true);
    }
  }, [hasAnswered]);

  const handleSubmit = async () => {
    if (textField === "") return;

    try {
      setIsLoading(true);
      const payload = {
        pollId,
        sessionId,
        trackId,
        answer: textField,
      };

      const { status } = await apiRequest(
        "POST",
        "/polls/wordcloud",
        [],
        payload
      );

      if (status === 200) {
        setTextField("");
        setIsLoading(false);
        setIsResponse(true);
        getHasAnswered();
      }
    } catch (e) {
      console.log(e);
    }
  };

  const handleReset = () => {
    setIsLoading(false);
    setIsResponse(false);
  };

  const isResponseAvailable = () => {
    if (!allowMultipleAnswers) {
      return !hasAnswered;
    }

    return true;
  };

  return (
    <div className="tm__polls">
      {/* Loader - Start */}
      {loading && (
        <div className="tm__polls-loader d-flex justify-content-center align-items-center">
          <div className="spinner-border text-primary" role="status"></div>
        </div>
      )}
      {/* Loader - End */}
      <div className="tm__polls-head tm__polls-head-divider">
        <label className="fs-7 text-primary mb-0">{question}</label>
      </div>
      <div className="tm__polls-body mt-5 mb-5">
        {/* Options - Start */}
        {!response && (
          <div>
            <input
              type="text"
              name="name"
              className="form-control"
              value={textField}
              maxLength={answerCharLimit}
              onChange={(e) => setTextField(e.target.value)}
              placeholder={t("POLLS_WORDCLOUD_PLACEHOLDER")}
              style={{ color: "white" }}
            />
          </div>
        )}
        {/* Options - End */}

        {/* Response - Start */}
        {response && showResults && (
          <TagCloud
            className="tm__word-cloud"
            minSize={12}
            maxSize={50}
            tags={wordCloudList}
            shuffle={true}
          />
        )}

        {response && !showResults && (
          <div className="tm__polls-body">
            {/* Response - Start */}
            <div className="d-flex flex-column align-items-center">
              <i className="bi bi-check-circle-fill text-primary fs-1"></i>
              <span>{t("POLLS_THANK_YOU_FOR_ANSWER")}</span>
            </div>
            {/* Response - End */}
          </div>
        )}
        {/* Response - End */}
      </div>
      {isResponseAvailable() && (
        <div className="tm__polls-footer tm__polls-footer-divider d-flex justify-content-center">
          {!response && (
            <button
              type="button"
              className="btn btn-primary btn-small"
              onClick={() => {
                handleSubmit();
              }}>
              {t("POLLS_SUBMIT_TEXT")}
            </button>
          )}
          {response && (
            <button
              type="button"
              className="btn btn-primary btn-small"
              onClick={() => {
                handleReset();
              }}>
              {t("POLLS_ADD_RESPONSE")}
            </button>
          )}
        </div>
      )}
    </div>
  );
};

export default WordCloud;
